import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  [class*="container"] {
    width: 100%;
    max-width: 100%;
  }
`;
